import { render } from "./S88803.vue?vue&type=template&id=c4dc65c0"
const script = {}
script.render = render

export default script